import { themes } from 'kb-shared';
import { History } from 'history';
import React, { FC } from 'react';
import styled from 'styled-components';

import { appointment as appointmentIcon } from '../../assets/icons';
import { DarkButton, OutlineButton } from '../Buttons';

type Props = {
  history: History;
};

type CtaProps = {
  history: History;
};

const AppointmentCTA: FC<CtaProps> = props => {
  return (
    <Container>
      <AppointmentIcon src={appointmentIcon} alt={'icon'} />
      <Text className="heading">Book your next appointment</Text>
      <Text className="body">
        {'We provide a complete suite of clinical care & coaching specially designed for women:'}
      </Text>
      <Text>
        <BulletText>
          <YellowBullet /> Fertility assessments, egg freezing, and IVF
        </BulletText>
        <BulletText>
          <YellowBullet />{' '}
          {
            'Gynecological services including well-woman check-ups, urgent care, and contraceptive & preconception counseling'
          }
        </BulletText>
        <BulletText>
          <YellowBullet />{' '}
          {
            'Therapy sessions & wellness coaching for fertility-related concerns and overall wellness'
          }
        </BulletText>
      </Text>
      <DarkButton style={{ marginTop: 28 }} onClick={() => props.history.push('/booking-quiz')}>
        BOOK AN APPOINTMENT
      </DarkButton>
    </Container>
  );
};

export default AppointmentCTA;

export const AppointmentCTAFooter = (props: Props) => (
  <FooterContainer>
    <Text className="footer">Need additional appointments?</Text>
    <OutlineButton small onClick={() => props.history.push('/booking-quiz')}>
      BOOK MORE
    </OutlineButton>
  </FooterContainer>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  border: solid 4px ${themes.colors.KBYellow};
  background-color: ${themes.colors.KBWhite};
  padding: 20px 25px 20px 25px;
`;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-grow: 1;
  background-color: ${themes.colors.KBBeige};
  padding: 20px 24px 20px 24px;
  z-index: 0;
`;

const AppointmentIcon = styled.img`
  width: 81px;
  height: 75px;
  object-fit: contain;
  margin-bottom: 20px;
`;

const BulletText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
`;

const Text = styled.div`
  color: ${themes.colors.KBNight};
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  font-size: 14px;

  &.heading {
    ${({ theme }) => theme.fonts.DomaineDisplay};
    font-size: 36px;
    text-align: center;
    margin-bottom: 20px;
  }

  &.body {
    font-weight: bold;
    letter-spacing: normal;
  }

  &.footer {
    max-width: 125px;
  }
`;

const YellowBulletWrapper = styled(Text)`
  font-size: 12px;
  color: ${themes.colors.KBYellow};
  margin-right: 4px;
  margin-top: 2px;
`;

const YellowBullet = () => {
  return <YellowBulletWrapper>◼</YellowBulletWrapper>;
};
